import { FC } from 'react';
import * as React from 'react';
import { useApi } from 'src/@context/Api';
import { makeStyles, createStyles } from '@material-ui/styles';
import spacing from 'src/constants/spacing';
import mediaQueries from 'src/constants/responsive';
import stylesheet, { backgroundColor, blue } from 'src/constants/stylesheet';
import * as classNames from 'classnames';

const useStyles = makeStyles(() =>
  createStyles({
    main: {
      flex: '1 1 auto',
    },
    footer: {
      flex: '0 0 auto',
      backgroundColor,
    },
    footerInner: {
      maxWidth: spacing.ContentMaxWidt,
      margin: '0 auto',
      boxSizing: 'content-box',
      [mediaQueries.Mobile]: {
        padding: '20px',
      },
      [mediaQueries.AfterMobile]: {
        padding: '30px 60px',
      }
    },
    footerContent: {
      display: 'flex',
      flexWrap: 'wrap',
      [mediaQueries.Mobile]: {},
      [mediaQueries.Tablet]: {
        marginLeft: -spacing.Gutter.Tablet / 2,
        marginRight: -spacing.Gutter.Tablet / 2,
      },
      [mediaQueries.Laptop]: {
        marginLeft: -spacing.Gutter.Laptop / 2,
        marginRight: -spacing.Gutter.Laptop / 2,
      },
      [mediaQueries.Desktop]: {
        marginLeft: -spacing.Gutter.Desktop / 2,
        marginRight: -spacing.Gutter.Desktop / 2,
      },
    },
    footerColumn: {
      boxSizing: 'border-box',

      [mediaQueries.Mobile]: {
        width: '100%',
        marginBottom: spacing.Gutter.Mobile,
        paddingBottom: spacing.Gutter.Mobile,
        borderBottom: `1px solid ${blue}`,
        textAlign: 'center',

        '&:last-child': {
          marginBottom: 0,
          borderBottom: 'none',
        }
      },
      [mediaQueries.TabletPortrait]: {
        width: '50%',
        paddingTop: 25,
        paddingLeft: 40,
        paddingRight: 40,
        paddingBottom: 25,
        '&:nth-child(-n+2)':{
          paddingTop: 0,
          borderBottom: `1px solid ${blue}`
        },
        '&:nth-child(n+2)':{
          paddingBottom: 0,
        },
      },
      [mediaQueries.TabletLandScape]: {
        width: '25%',
      },
      [mediaQueries.AfterTablet]: {
        width: '25%',
        paddingLeft: spacing.Gutter.Tablet / 2,
        paddingRight: spacing.Gutter.Tablet / 2,
      },
      [mediaQueries.Laptop]: {
        paddingLeft: spacing.Gutter.Laptop / 2,
        paddingRight: spacing.Gutter.Laptop / 2,
      },
      [mediaQueries.Desktop]: {
        paddingLeft: spacing.Gutter.Desktop / 2,
        paddingRight: spacing.Gutter.Desktop / 2,
      },
    },
    footerColumnTitle: {
      ...stylesheet.TitleH3,
      marginBottom: '.8em',

      [mediaQueries.Mobile]:{
        textTransform: 'uppercase',
      },
    },
    footerColumnText: {},
    socialIconsContainer: {
      display: 'flex',

      [mediaQueries.Mobile]: {
        justifyContent: 'center',
      },
    },
    socialLink: {
      width: 45,    
      display: 'block',
      background: 'white',
      borderRadius: '100%',
      lineHeight: 1,

      [mediaQueries.Mobile]: {
        margin: '0 5px',
      },
      [mediaQueries.AfterMobile]: {
       marginRight: 10,
      },

      '& svg': {
        width: '100%',
        display: 'block',
      },

      '&:hover':{
        background: blue,
      }
    },
    fill: {
      fill: blue,
      '$socialLink:hover &':{
        fill: 'white',
      }
    },
    copywrite: {
      fontSize: '.9rem',
      [mediaQueries.Mobile]: {
       textAlign: 'center',
      },
      [mediaQueries.TabletPortrait]: {
        paddingLeft: 40,
        paddingRight: 40,
        margin: `20px ${-spacing.Gutter.Tablet / 2}px 0 ${-spacing.Gutter.Tablet / 2}px`
       },
      [mediaQueries.TabletLandScape]: {
        marginTop: 20,
       },
      [mediaQueries.AfterTablet]: {
        marginTop: 20,
       },
    },
    formContainer:{
      marginBottom: 30
    },
    inputContainer:{
      position:'relative',
      backgroundColor: 'white',
      padding: '10px 40px 10px 10px',
      display: 'flex',
      borderBottomRightRadius: 20,

      [mediaQueries.Mobile]:{
        padding: '10px 40px 10px 20px',
        borderRadius: 20,
      }
    },
    submit:{
      flex: '0 0 auto',
      position: 'absolute',
      right: 10,
      top: '50%',
      transform: 'translateY(-50%)',
      width: 20,
      marginTop:1,
      cursor: 'pointer',

      [mediaQueries.Mobile]:{
        right: 20,
      }
    },
    input: {
      width: '100%',
      border: 'none',
      outline: 'none',
      margin: 0,
      fontSize: '1rem',
      color: blue,

      '&::placeholder':{
        color: blue,
      }
    }
  }));
export type FooterProps = {};
type Props = FooterProps;

const Footer: FC<Props> = () => {
  const cls = useStyles();
  const { app } = useApi();

  const config = app && app.Config;
  const translationsItems = config && config.TranslationItems;
  const emailTranslation = translationsItems && translationsItems.find(t => t.UID === 'footer_email');

  React.useEffect(() => {
    const script = document.createElement("script");

    script.src = "https://js.createsend1.com/javascript/copypastesubscribeformlogic.js";
    script.type = "text/javascript"
    // script.async = true;

    document.head.appendChild(script)
  }, [])

  const facebooSVG = 
    <svg 
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 45.8 45.8"
      enableBackground="new 0 0 45.8 45.8;" 
    >
      <g>
        <path className={cls.fill} d="M19.3,16.4V20h-2.6v4.3h2.6v12.8h5.3V24.3h3.6c0,0,0.4-2.1,0.5-4.3h-4v-3c0-0.5,0.6-1,1.2-1h2.9v-4.5h-3.9
          C19.2,11.5,19.3,15.8,19.3,16.4"/>
      </g>
    </svg>;

    const vimeoSVG = 
    <svg 
      version="1.1"
      xmlns="http://www.w3.org/2000/svg" 
      x="0px"
      y="0px"
      viewBox="0 0 45.8 45.8"
      enableBackground="new 0 0 45.8 45.8;"
    >
      <g>
      <path className={cls.fill} d="M32.8,19.4c1.1-6.5-7.6-5.1-8.4,0.5c2.3-1.4,3.5,0.6,2.4,2.8c-1.2,2.3-2.2,3.7-2.8,3.7c-0.6,0-1-1.5-1.6-4.2
      c-0.6-2.7-0.7-7.7-3.4-7.1c-1.3,0.3-2.8,1.4-4,2.5c-0.7,0.7-1.4,1.4-2,2.2l0.8,1.1c0.3-0.2,0.6-0.5,0.9-0.6c0.5-0.3,1-0.4,1.3-0.1
          c0.5,0.7,2.7,8.9,3.4,10.4c0.7,1.4,2.3,3.1,4.2,1.9C25.4,31.4,31.8,25.9,32.8,19.4"/>
      </g>
    </svg>;

    const instSVG = 
    <svg 
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 45.8 45.8"
      enableBackground="new 0 0 45.8 45.8;"
    >
      <g>
        <path className={cls.fill} d="M18.2,11.6c-1.2,0-2.1,0.3-2.8,0.5c-0.8,0.3-1.4,0.7-2,1.3s-1,1.3-1.3,2c-0.3,0.7-0.5,1.6-0.5,2.8
        c0,1.2-0.1,1.6-0.1,4.7s0,3.5,0.1,4.7c0,1.2,0.3,2.1,0.5,2.8c0.3,0.8,0.7,1.4,1.3,2s1.3,1,2,1.3s1.6,0.5,2.8,0.5s1.6,0.1,4.7,0.1
        s3.5,0,4.7-0.1c1.2,0,2.1-0.3,2.8-0.5c0.8-0.3,1.4-0.7,2-1.3c0.6-0.6,1-1.3,1.3-2s0.5-1.6,0.5-2.8c0.1-1.2,0.1-1.6,0.1-4.7
        s0-3.5-0.1-4.7c0-1.2-0.3-2.1-0.5-2.8c-0.3-0.8-0.7-1.4-1.3-2c-0.6-0.6-1.3-1-2-1.3c-0.7-0.3-1.6-0.5-2.8-0.5
        c-1.2,0-1.6-0.1-4.7-0.1C19.8,11.5,19.5,11.5,18.2,11.6 M18.3,32.3c-1.1,0-1.7-0.2-2.1-0.4c-0.5-0.2-0.9-0.4-1.3-0.9
        c-0.4-0.4-0.6-0.8-0.9-1.3c-0.1-0.4-0.4-1-0.4-2.1c0-1.2,0-1.6,0-4.6s0-3.4,0-4.6c0-1.1,0.2-1.7,0.4-2.1c0.2-0.5,0.4-0.9,0.9-1.3
        c0.4-0.4,0.8-0.6,1.3-0.9c0.4-0.1,1-0.4,2.1-0.4c1.2,0,1.6,0,4.6,0c3.1,0,3.4,0,4.6,0c1.1,0,1.7,0.2,2.1,0.4
        c0.5,0.2,0.9,0.4,1.3,0.9c0.4,0.4,0.6,0.8,0.9,1.3c0.1,0.4,0.4,1,0.4,2.1c0,1.2,0,1.6,0,4.6s0,3.4,0,4.6c0,1.1-0.2,1.7-0.4,2.1
        c-0.2,0.5-0.5,0.9-0.9,1.3c-0.4,0.4-0.8,0.6-1.3,0.9c-0.4,0.1-1,0.4-2.1,0.4c-1.2,0-1.6,0-4.6,0C19.9,32.4,19.5,32.4,18.3,32.3
         M27.7,16.8c0,0.8,0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4C28.3,15.4,27.7,16.1,27.7,16.8 M17.1,23
        c0,3.2,2.7,5.9,5.9,5.9s5.8-2.7,5.8-5.9s-2.7-5.9-5.9-5.9S17.1,19.7,17.1,23 M19.1,23c0-2.1,1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8
        s-1.7,3.8-3.8,3.8C20.8,26.8,19.1,25.1,19.1,23"/>
      </g>
    </svg>;

    const submitSVG = 
    <svg 
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 20.2 20.2"
      enableBackground="new 0 0 20.2 20.2;"
      >
        <g>
        <path className={cls.fill} d="M0.1,11.6c0-0.4,0.3-0.5,0.7-0.7c1-0.6,18.5-10.6,18.5-10.6s0.5-0.3,0.8-0.1c0.2,0.1,0.1,0.6,0.1,0.6l-0.2,1.4
            c0,0-1.1,6.5-1.6,9.8c-0.3,2-0.6,3.9-1,5.9c-0.1,0.5-0.5,0.8-1,0.6c-0.5-0.2-0.9-0.4-1.4-0.6c-1.2-0.5-2.4-1-3.6-1.5
            c-0.6,0.8-1.3,1.6-1.9,2.3c-0.4,0.4-1,1.1-1.1,1.2c-0.2,0.1-0.2,0-0.4,0c-0.4-0.2-0.5-0.5-0.5-1l0-3.1c0-0.3,0.1-0.6,0.3-0.9
            c2.4-2.9,8.5-10.4,8.5-10.4s-7.1,5.8-10.7,8.9c-0.2,0.2-0.7,0.1-0.7,0.1S0.1,12,0.1,11.6"/>
        </g>
      </svg>

  return (
    <div className={cls.footer}>
      {config &&
        <div className={cls.footerInner}>
          <div className={cls.footerContent}>
            <div className={cls.footerColumn}>
              <div className={cls.footerColumnTitle}>{config.ContactTitle}</div>
              <div className={cls.footerColumnText} dangerouslySetInnerHTML={{ __html: config.ContactText }} />
            </div>
            <div className={cls.footerColumn}>
              <div className={cls.footerColumnTitle}>{config.LabelsTitle}</div>
              <div className={cls.footerColumnText} dangerouslySetInnerHTML={{ __html: config.LabelsText }} />
            </div>
            <div className={cls.footerColumn}>
              <div className={cls.footerColumnTitle}>{config.ExtraTitle}</div>
              <div className={cls.footerColumnText} dangerouslySetInnerHTML={{ __html: config.ExtraText }} />
            </div>
            <div className={cls.footerColumn}>
              <div className={cls.footerColumnTitle}>Newsletter</div>
              <div className={cls.formContainer}>
                <form 
                  className="js-cm-form"
                  id="subForm" 
                  action="https://www.createsend.com/t/subscribeerror?description="
                  method="post" 
                  data-id="5B5E7037DA78A748374AD499497E309EE1E84C099CC6610DE580837BDCE4ED511AF3F645C8E0A20FCE8E31AD230F2382AA1E5E792D937ED1FC58A2F4B6D08FFE"
                >
                  <div className={cls.inputContainer}>
                        <input 
                          autoComplete='Email'
                          aria-label="Email" 
                          // class="js-cm-email-input" 
                          className={classNames(cls.input, 'js-cm-email-input')}
                          id={"fieldEmail"}
                          maxLength={200} 
                          name={"cm-oddtrti-oddtrti"}
                          required={true} 
                          type="email"
                          placeholder={emailTranslation?.Translation || ''}
                        />
                      <button className={cls.submit} type="submit">{submitSVG}</button>
                    </div>
                  </form>
              </div>
              <div className={cls.footerColumnTitle}>
                <div className={cls.footerColumnTitle}>{config.Socials}</div>
                <div className={cls.socialIconsContainer}>
                  {config.Facebook && 
                      <a href={config.Facebook} className={cls.socialLink} target='_black'>{facebooSVG}</a>}

                  {config.Instagram && 
                    <a href={config.Instagram} className={cls.socialLink} target='_black'>{instSVG}</a>}

                  {config.Vimeo && 
                    <a href={config.Vimeo} className={cls.socialLink} target='_black'>{vimeoSVG}</a>}
                </div>
              </div>
            </div>
          </div>
          <div className={cls.copywrite}>© Marinex SA</div>
        </div>
      }
    </div>
  );
};

export default Footer;


// WEBPACK FOOTER //
// ./src/Components/Footer.tsx